import EmbedMedia from './EmbedMedia'

export default EmbedMedia

export * from './EmbedMedia'
